import { InvoicesPage } from '../pages/InvoicesPage';
import { NeedToPayPage } from '../pages/NeedToPayPage';
import { PaidOutPage } from '../pages/PaidOutPage';
import { ReTestBonusesPage } from '@app/domain/finding/ReTestBonuses.page';

export const AllFinanceTabsWrapper = () => {
  return (
    <>
      <InvoicesPage />
      <NeedToPayPage />
      <PaidOutPage />
      <ReTestBonusesPage />
    </>
  );
};
